import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentsModule } from '@freelancer/components';
import { DatastoreRecommendedUsernamesModule } from '@freelancer/datastore/collections';
import { UiModule } from '@freelancer/ui';
import { FormLogoModule } from '../form-logo/form-logo.module';
import { LoginSignupButtonsModule } from '../login-signup-buttons.module';
import { LoginSignupErrorsModule } from '../login-signup-errors/login-signup-errors.module';
import { UsernameSelectFormComponent } from './username-select-form.component';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    DatastoreRecommendedUsernamesModule,
    LoginSignupButtonsModule,
    LoginSignupErrorsModule,
    FormLogoModule,
    UiModule,
  ],
  declarations: [UsernameSelectFormComponent],
  exports: [UsernameSelectFormComponent],
})
export class UsernameSelectModule {}
